import React from "react";
import {aggregateFacility} from "../Helper/FacilityAggregators";
import {IFacility} from "../types";
import {OptionalId} from "../../index";
import {IOSummary} from "./IOSummary";
import {ItemThroughput} from "./ItemStack";

type Props = {
    facility: OptionalId<IFacility>,
    InputChildren?: React.FC,
    OutputChildren?: React.FC,
};

export function FacilityIOSummary({facility, InputChildren = () => null, OutputChildren = () => null}: Props) {
    const {ingredients, products} = aggregateFacility(facility);

    return <IOSummary StackRender={ItemThroughput} ingredients={ingredients} products={products} gameType={facility.game} InputChildren={InputChildren} OutputChildren={OutputChildren} />;
}
